import Products from "../products/Products";

function PriceList({ searchTerm }: { searchTerm?: string }) {
  return <Products searchTerm={searchTerm} prices />;
}

export default PriceList;
